import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import ScienceIcon from "@mui/icons-material/Science";
import { Box, Chip } from "@mui/material";
import { useIntl } from "react-intl";
import { IUserSkuExtended } from "services/KnowfullyAdminClient";

const styles = {
  cell: { display: "flex", flexWrap: "wrap", gap: 0.75 },
  chip: {
    borderRadius: 2,
    fontSize: 13,
    "& .MuiChip-icon": { color: "inherit", fontSize: 18 },
  },
  trial: {
    color: "#327999",
    backgroundColor: "#F5F8FA",
    borderColor: "#C9D5DA",
  },
  // Darker than the #BF5742 border so the label meets 4.5:1 on its background.
  test: {
    color: "#A84A37",
    backgroundColor: "#FBF4F2",
    borderColor: "#BF5742",
  },
};

type UserSkuTypeCellProps = {
  value: Pick<IUserSkuExtended, "isTrial" | "isTest">;
};

export const UserSkuTypeCell = ({ value }: UserSkuTypeCellProps) => {
  const { formatMessage: t } = useIntl();

  return (
    <Box sx={styles.cell}>
      {value.isTrial && (
        <Chip
          size="small"
          variant="outlined"
          icon={<HourglassTopIcon />}
          label={t({ id: "trial" })}
          sx={[styles.chip, styles.trial]}
        />
      )}
      {value.isTest && (
        <Chip
          size="small"
          variant="outlined"
          icon={<ScienceIcon />}
          label={t({ id: "test" })}
          sx={[styles.chip, styles.test]}
        />
      )}
    </Box>
  );
};
